export const TRIGGER_VALUES = {
  following: 'On-Follow',
  applying: 'Marked-Applying',
  applied: 'Marked-Applied',
}

export const TRIGGER_LABELS = {
  following: 'Following',
  applying: 'Applying',
  applied: 'Applied',
}

export const AUTOMATED_TRIGGER_CONFIGS = [
  {
    label: TRIGGER_LABELS.following,
    value: TRIGGER_VALUES.following,
  },
  {
    label: TRIGGER_LABELS.applying,
    value: TRIGGER_VALUES.applying,
  },
  {
    label: TRIGGER_LABELS.applied,
    value: TRIGGER_VALUES.applied,
  },
]

export const PARENT_TRIGGER_DESCRIPTIONS = {
  following: 'Sent to parents when their student adds your school to My Colleges',
  applying: 'Sent to parents when their student marks they intend to apply to your school',
  applied: 'Sent to parents when their student has applied to your school',
}

export const STUDENT_TRIGGER_DESCRIPTIONS = {
  following: 'Sent when a student adds your school to My Colleges',
  applying: 'Sent when a student marks they intend to apply to your school',
  applied: 'Sent when a student has applied to your school',
}

export const DEFAULT_AUTOMATED_TRIGGER = AUTOMATED_TRIGGER_CONFIGS[0].value

export const ONE_TIME_TRIGGER = 'One-Time'
